import React from "react";
import { useNavigate } from "react-router-dom";

const ComingSoon = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#fff] dark:bg-[#121519] px-4 transition-colors duration-300">
      
      <div className="bg-white dark:bg-[#1a1d21] shadow-xl rounded-2xl p-6 md:p-10 text-center max-w-md w-full">
        
        <h1 className="text-2xl md:text-4xl font-bold text-gray-800 dark:text-white">
          Coming Soon 🚀
        </h1>

        <p className="text-gray-500 dark:text-gray-400 mt-3 text-sm md:text-base">
          We’re working hard to bring something amazing. Stay tuned!
        </p>

        <div className="w-16 h-1 bg-black dark:bg-white mx-auto my-5 rounded"></div>

        <button
          onClick={() => navigate("/ProductsHome")}
          className="mt-4 px-5 py-2 bg-black dark:bg-white text-white dark:text-black rounded-lg text-sm hover:bg-gray-800 dark:hover:bg-gray-300 transition duration-300"
        >
          ← Back to Home
        </button>
      </div>

     
     
    </div>
  );
};

export default ComingSoon;